import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';

/**
 * PageSheet — a drop-in replacement for a page's content <Container> that
 * renders the page as a raised "sheet" floating on the sand background: a warm
 * off-white surface with rounded corners and a soft shadow, inset on every side
 * so a thin strip of the brand sand always frames it. The sand background and
 * navy header stay unchanged.
 *
 * Accepts all Container props (maxWidth, sx, disableGutters, …).
 */
const PageSheet = styled(Container)(({ theme }) => ({
  backgroundColor: '#F7F3EC',
  borderRadius: 22,
  boxShadow: '0 10px 30px -18px rgba(17, 34, 62, 0.5)',
  paddingTop: theme.spacing(2.5),
  paddingBottom: theme.spacing(3),
  minHeight: 'calc(100dvh - 172px)',
  // Inset on all sides so the sand shows as a thin frame. On phones this is a
  // small fixed margin; from sm up the centred maxWidth already leaves side sand.
  width: 'auto',
  marginTop: theme.spacing(1.5),
  marginBottom: theme.spacing(2.5),
  marginLeft: theme.spacing(1.5),
  marginRight: theme.spacing(1.5),
  [theme.breakpoints.up('sm')]: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

export default PageSheet;
